import {ModuleConfiguration} from "../router/model/UserPermission";
import {CustomerListModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const CustomerListModuleConfiguration =
    new ModuleConfiguration(
        CustomerListModuleName,
        [AngularJsMaterialModuleName]
    );